<div class="row align-items-center">
  <div class="col text-muted text-uppercase small font-weight-bold">
    {{ title }}:
    <i
      *ngIf="tooltipText"
      class="fe fe-info fe-fw"
      [ngbTooltip]="tooltipText"
    ></i>
  </div>
  <div class="col-auto font-weight-bold text-right">
    <span class="h3 mb-1 d-block" *ngFor="let total of data">
      {{ total.value | pepCurrency: total.currency:locale }}
    </span>
    <span class="h3 mb-0" *ngIf="data.length === 0">
      {{ '0' | pepCurrency: defaultCurrency:locale }}
    </span>
  </div>
</div>
